module.exports = __webpack_public_path__ + "media/recipes/94-0dfd4984.png";